import { getPosSettings } from "../utils/posSettings";

export const DEFAULT_CURRENCY_CODE = process.env.REACT_APP_CURRENCY_CODE || "PKR";
export const DEFAULT_CURRENCY_LOCALE = process.env.REACT_APP_CURRENCY_LOCALE || "en-PK";

export const CURRENCY_CODE = DEFAULT_CURRENCY_CODE;
export const CURRENCY_LOCALE = DEFAULT_CURRENCY_LOCALE;

const CURRENCY_LOCALES: Record<string, string> = {
  PKR: "en-PK",
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
  AED: "en-AE",
  SAR: "en-SA",
};

export const formatCurrency = (amount: number | string, customCode?: string): string => {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (isNaN(num)) return "N/A";
  const code = customCode || (typeof window !== "undefined" ? getPosSettings().currencySymbol : DEFAULT_CURRENCY_CODE) || DEFAULT_CURRENCY_CODE;
  const locale = CURRENCY_LOCALES[code] || DEFAULT_CURRENCY_LOCALE;
  return `${code} ${num.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
